module.exports = __webpack_public_path__ + "static/media/angleLeft.41f05345.svg";